var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "b-dropdown",
        {
          attrs: {
            position: "is-bottom-left",
            "append-to-body": "",
            "aria-role": "list",
          },
          scopedSlots: _vm._u(
            [
              _vm.hasButton
                ? {
                    key: "trigger",
                    fn: function () {
                      return [
                        _c(
                          "b-tooltip",
                          {
                            attrs: {
                              label: _vm.$t(
                                "admin.component.loggers.detail.actions.title"
                              ),
                              position: "is-left",
                              type: "is-dark",
                            },
                          },
                          [
                            _c(
                              "b-button",
                              { staticStyle: { "font-size": "1rem" } },
                              [
                                _c("b-icon", {
                                  attrs: {
                                    type: "is-primary",
                                    icon: "ellipsis-v",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  }
                : {
                    key: "trigger",
                    fn: function () {
                      return [
                        _c(
                          "b-button",
                          {
                            attrs: {
                              "icon-pack": "fa",
                              "icon-right": "angle-down",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "admin.component.loggers.detail.actions.title"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]
                    },
                    proxy: true,
                  },
            ],
            null,
            true
          ),
        },
        [
          _c(
            "b-dropdown-item",
            {
              staticClass: "custom-dropdown-item",
              attrs: { custom: "", focusable: false, "aria-role": "listitem" },
            },
            [
              _c(
                "span",
                { staticClass: "is-italic has-text-weight-bold has-text-grey" },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "admin.component.devices.detail.actions.sales_group"
                      )
                    )
                  ),
                ]
              ),
            ]
          ),
          _c(
            "b-dropdown-item",
            {
              staticClass: "custom-dropdown-item",
              attrs: {
                "aria-role": "listitem",
                disabled: !(
                  _vm.adminDevice.instanceState ===
                    _vm.DeviceInstanceState.ACTIVE &&
                  _vm.adminDevice.state === _vm.DeviceState.REGISTERED &&
                  _vm.$userCan(_vm.$adminPermissions.ADMIN_GATEWAYS_RETURN)
                ),
              },
              on: {
                click: function ($event) {
                  return _vm.reuseDevice()
                },
              },
            },
            [
              _c("div", { staticClass: "level is-mobile" }, [
                _c(
                  "div",
                  { staticClass: "level-left" },
                  [
                    _c("b-icon", { attrs: { icon: "undo-alt" } }),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("admin.component.devices.detail.actions.reuse")
                        )
                      ),
                    ]),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "level-right",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                      },
                    },
                  },
                  [
                    _c(
                      "b-tooltip",
                      {
                        attrs: {
                          type: "is-dark",
                          label: _vm.$t(
                            "admin.component.devices.detail.actions.reuseNote",
                            { name: _vm.adminDevice.deviceName }
                          ),
                          position: "is-left",
                          multilined: "",
                        },
                      },
                      [
                        _c("b-icon", {
                          attrs: {
                            size: "is-small",
                            icon: "question-circle",
                            type: "is-grey",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
          _c(
            "b-dropdown-item",
            {
              staticClass: "custom-dropdown-item",
              attrs: {
                "aria-role": "listitem",
                disabled:
                  _vm.adminDevice.instanceState ===
                    _vm.DeviceInstanceState.ACTIVE &&
                  _vm.adminDevice.state === _vm.DeviceState.REGISTERED &&
                  _vm.$userCan(_vm.$adminPermissions.ADMIN_GATEWAYS_RETURN)
                    ? false
                    : true,
              },
              on: {
                click: function ($event) {
                  return _vm.returnDeviceFromCompany()
                },
              },
            },
            [
              _c("div", { staticClass: "level is-mobile" }, [
                _c(
                  "div",
                  { staticClass: "level-left" },
                  [
                    _c("b-icon", { attrs: { icon: "minus" } }),
                    _c("span", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              "admin.component.devices.detail.actions.return"
                            )
                          )
                      ),
                    ]),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "level-right",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                      },
                    },
                  },
                  [
                    _c(
                      "b-tooltip",
                      {
                        attrs: {
                          type: "is-dark",
                          label: _vm.$t(
                            "admin.component.devices.detail.actions.returnNote",
                            { name: _vm.adminDevice.deviceName }
                          ),
                          position: "is-left",
                          multilined: "",
                        },
                      },
                      [
                        _c("b-icon", {
                          attrs: {
                            size: "is-small",
                            icon: "question-circle",
                            type: "is-grey",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
          _c(
            "b-dropdown-item",
            {
              staticClass: "custom-dropdown-item",
              attrs: {
                "aria-role": "listitem",
                disabled:
                  _vm.adminDevice.instanceState ===
                    _vm.DeviceInstanceState.INACTIVE &&
                  _vm.adminDevice.state === _vm.DeviceState.ACTIVATED &&
                  _vm.$userCan(_vm.$adminPermissions.ADMIN_GATEWAYS_REGISTER)
                    ? false
                    : true,
              },
              on: {
                click: function ($event) {
                  return _vm.registerToCompany()
                },
              },
            },
            [
              _c("div", { staticClass: "level is-mobile" }, [
                _c(
                  "div",
                  { staticClass: "level-left" },
                  [
                    _c("b-icon", { attrs: { icon: "plus" } }),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "admin.component.devices.detail.actions.register"
                          )
                        )
                      ),
                    ]),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "level-right",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                      },
                    },
                  },
                  [
                    _c(
                      "b-tooltip",
                      {
                        attrs: {
                          type: "is-dark",
                          label: _vm.$t(
                            "admin.component.devices.detail.actions.registerNote",
                            { name: _vm.adminDevice.deviceName }
                          ),
                          position: "is-left",
                          multilined: "",
                        },
                      },
                      [
                        _c("b-icon", {
                          attrs: {
                            size: "is-small",
                            icon: "question-circle",
                            type: "is-grey",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
          _c(
            "b-dropdown-item",
            {
              staticClass: "custom-dropdown-item",
              attrs: { custom: "", focusable: false, "aria-role": "listitem" },
            },
            [
              _c(
                "span",
                { staticClass: "is-italic has-text-weight-bold has-text-grey" },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "admin.component.devices.detail.actions.tech_group"
                      )
                    )
                  ),
                ]
              ),
            ]
          ),
          _c(
            "b-dropdown-item",
            {
              staticClass: "custom-dropdown-item",
              attrs: { "aria-role": "listitem" },
              on: {
                click: function ($event) {
                  return _vm.openDeviceMonitor()
                },
              },
            },
            [
              _c("b-icon", { attrs: { icon: "desktop" } }),
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.$t("admin.component.devices.detail.actions.monitor")
                  )
                ),
              ]),
            ],
            1
          ),
          _c(
            "b-dropdown-item",
            {
              staticClass: "custom-dropdown-item",
              attrs: {
                "aria-role": "listitem",
                disabled: _vm.$userCan(
                  _vm.$adminPermissions.ADMIN_GATEWAYS_CONFIGURE
                )
                  ? false
                  : true,
              },
              on: {
                click: function ($event) {
                  return _vm.configureDevice()
                },
              },
            },
            [
              _c("div", { staticClass: "level is-mobile" }, [
                _c(
                  "div",
                  { staticClass: "level-left" },
                  [
                    _c("b-icon", { attrs: { icon: "cog" } }),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "admin.component.devices.detail.actions.configure"
                          )
                        )
                      ),
                    ]),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "level-right",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                      },
                    },
                  },
                  [
                    _c(
                      "b-tooltip",
                      {
                        attrs: {
                          type: "is-dark",
                          label: _vm.$t(
                            "admin.component.devices.detail.actions.warningNote",
                            { name: _vm.adminDevice.deviceName }
                          ),
                          position: "is-left",
                          multilined: "",
                        },
                      },
                      [
                        _c("b-icon", {
                          attrs: {
                            size: "is-small",
                            icon: "question-circle",
                            type: "is-grey",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
          _c(
            "b-dropdown-item",
            {
              staticClass: "custom-dropdown-item",
              attrs: {
                "aria-role": "listitem",
                disabled: _vm.$userCan(
                  _vm.$adminPermissions.ADMIN_GATEWAYS_UPDATES_SCHEDULE
                )
                  ? false
                  : true,
              },
              on: {
                click: function ($event) {
                  return _vm.otaUpdateDevice()
                },
              },
            },
            [
              _c("div", { staticClass: "level is-mobile" }, [
                _c(
                  "div",
                  { staticClass: "level-left" },
                  [
                    _c("b-icon", { attrs: { icon: "sync" } }),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "admin.component.devices.detail.actions.update"
                          )
                        )
                      ),
                    ]),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "level-right",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                      },
                    },
                  },
                  [
                    _c(
                      "b-tooltip",
                      {
                        attrs: {
                          type: "is-dark",
                          label: _vm.$t(
                            "admin.component.devices.detail.actions.warningNote",
                            { name: _vm.adminDevice.deviceName }
                          ),
                          position: "is-left",
                          multilined: "",
                        },
                      },
                      [
                        _c("b-icon", {
                          attrs: {
                            size: "is-small",
                            icon: "question-circle",
                            type: "is-grey",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
          _c(
            "b-dropdown-item",
            {
              staticClass: "custom-dropdown-item",
              attrs: {
                "aria-role": "listitem",
                disabled: _vm.$userCan(
                  _vm.$adminPermissions.ADMIN_GATEWAYS_CREDENTIALS_EDIT
                )
                  ? false
                  : true,
              },
              on: {
                click: function ($event) {
                  return _vm.keyUpdate()
                },
              },
            },
            [
              _c("div", { staticClass: "level is-mobile" }, [
                _c(
                  "div",
                  { staticClass: "level-left mr-1" },
                  [
                    _c("b-icon", { attrs: { icon: "magic" } }),
                    _c("span", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              "admin.component.devices.detail.actions.keyUpdate"
                            )
                          )
                      ),
                    ]),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "level-right",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                      },
                    },
                  },
                  [
                    _c(
                      "b-tooltip",
                      {
                        attrs: {
                          type: "is-dark",
                          label: _vm.$t(
                            "admin.component.devices.detail.actions.warningNote"
                          ),
                          position: "is-left",
                          multilined: "",
                        },
                      },
                      [
                        _c("b-icon", {
                          attrs: {
                            size: "is-small",
                            icon: "question-circle",
                            type: "is-grey",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
          _c(
            "b-dropdown-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: false,
                  expression: "false",
                },
              ],
              staticClass: "custom-dropdown-item",
              attrs: {
                "aria-role": "listitem",
                disabled: _vm.$userCan(
                  _vm.$adminPermissions.ADMIN_GATEWAYS_REVERT
                )
                  ? false
                  : true,
              },
              on: {
                click: function ($event) {
                  return _vm.revertDevice()
                },
              },
            },
            [
              _c("div", { staticClass: "level is-mobile" }, [
                _c(
                  "div",
                  { staticClass: "level-left" },
                  [
                    _c("b-icon", { attrs: { icon: "history" } }),
                    _c("span", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              "admin.component.devices.detail.actions.revert"
                            )
                          ) +
                          " "
                      ),
                    ]),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "level-right",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                      },
                    },
                  },
                  [
                    _c(
                      "b-tooltip",
                      {
                        attrs: {
                          type: "is-dark",
                          label: _vm.$t(
                            "admin.component.devices.detail.actions.revertNote"
                          ),
                          position: "is-left",
                          multilined: "",
                        },
                      },
                      [
                        _c("b-icon", {
                          attrs: {
                            size: "is-small",
                            icon: "question-circle",
                            type: "is-grey",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
          _c(
            "b-dropdown-item",
            {
              staticClass: "custom-dropdown-item",
              attrs: {
                "aria-role": "listitem",
                disabled:
                  _vm.adminDevice.state === _vm.DeviceState.CREATED &&
                  _vm.$userCan(_vm.$adminPermissions.ADMIN_GATEWAYS_ACTIVATE)
                    ? false
                    : true,
              },
              on: {
                click: function ($event) {
                  return _vm.activateDevice()
                },
              },
            },
            [
              _c("div", { staticClass: "level is-mobile" }, [
                _c(
                  "div",
                  { staticClass: "level-left" },
                  [
                    _c("b-icon", { attrs: { icon: "power-off" } }),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "admin.component.devices.detail.actions.activate"
                          )
                        )
                      ),
                    ]),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "level-right",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                      },
                    },
                  },
                  [
                    _c(
                      "b-tooltip",
                      {
                        attrs: {
                          type: "is-dark",
                          label: _vm.$t(
                            "admin.component.devices.detail.actions.activateNote"
                          ),
                          position: "is-left",
                          multilined: "",
                        },
                      },
                      [
                        _c("b-icon", {
                          attrs: {
                            size: "is-small",
                            icon: "question-circle",
                            type: "is-grey",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
          _c(
            "b-dropdown-item",
            {
              staticClass: "custom-dropdown-item",
              attrs: {
                "aria-role": "listitem",
                disabled:
                  (_vm.adminDevice.state === _vm.DeviceState.CREATED ||
                    _vm.adminDevice.state === _vm.DeviceState.ACTIVATED) &&
                  _vm.$userCan(_vm.$adminPermissions.ADMIN_GATEWAYS_PUBLISH)
                    ? false
                    : true,
              },
              on: {
                click: function ($event) {
                  return _vm.publishDevice()
                },
              },
            },
            [
              _c("div", { staticClass: "level is-mobile" }, [
                _c(
                  "div",
                  { staticClass: "level-left" },
                  [
                    _c("b-icon", { attrs: { icon: "upload" } }),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "admin.component.devices.detail.actions.publish"
                          )
                        )
                      ),
                    ]),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "level-right",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                      },
                    },
                  },
                  [
                    _c(
                      "b-tooltip",
                      {
                        attrs: {
                          type: "is-dark",
                          label: _vm.$t(
                            "admin.component.devices.detail.actions.publishNote",
                            { name: _vm.adminDevice.deviceName }
                          ),
                          position: "is-left",
                          multilined: "",
                        },
                      },
                      [
                        _c("b-icon", {
                          attrs: {
                            size: "is-small",
                            icon: "question-circle",
                            type: "is-grey",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }